/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { GlobalAdministrator } from "../operationsInterfaces";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { AuthorizationManagementClient } from "../authorizationManagementClient";
import { GlobalAdministratorElevateAccessOptionalParams } from "../models";

/** Class containing GlobalAdministrator operations. */
export class GlobalAdministratorImpl implements GlobalAdministrator {
  private readonly client: AuthorizationManagementClient;

  /**
   * Initialize a new instance of the class GlobalAdministrator class.
   * @param client Reference to the service client
   */
  constructor(client: AuthorizationManagementClient) {
    this.client = client;
  }

  /**
   * Elevates access for a Global Administrator.
   * @param options The options parameters.
   */
  elevateAccess(
    options?: GlobalAdministratorElevateAccessOptionalParams
  ): Promise<void> {
    return this.client.sendOperationRequest(
      { options },
      elevateAccessOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const elevateAccessOperationSpec: coreClient.OperationSpec = {
  path: "/providers/Microsoft.Authorization/elevateAccess",
  httpMethod: "POST",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ErrorResponse
    }
  },
  queryParameters: [Parameters.apiVersion],
  urlParameters: [Parameters.$host],
  headerParameters: [Parameters.accept],
  serializer
};
